import React, { useState } from 'react';

const ModulePMR = () => {
  const [formData, setFormData] = useState({
    type: 'Particulier',
    nom: '',
    adresseFacturation: '',
    passagers: '1',
    typePrestation: 'Trajet',
    dep: '',
    arr: '',
    tel: '',
    email: '',
    notes: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.nom || !formData.adresseFacturation || !formData.dep || !formData.arr) {
      alert('⚠️ Veuillez remplir tous les champs obligatoires (Nom, Adresse, Départ, Arrivée)');
      return;
    }

    // Préparation du message WhatsApp
    const tel = formData.tel || '0695731320'; // Numéro par défaut si non renseigné
    let telFormatted = tel.startsWith('0') ? '33' + tel.substring(1) : tel;
    telFormatted = telFormatted.replace(/\s+/g, '');

    const message = `🚐 DEMANDE TRANSPORT PMR\n\n` +
      `Type : ${formData.type}\n` +
      `${formData.type === 'Particulier' ? 'Nom' : 'Société'} : ${formData.nom}\n` +
      `Adresse de facturation : ${formData.adresseFacturation}\n` +
      `Passagers : ${formData.passagers}\n\n` +
      `Prestation : ${formData.typePrestation}\n` +
      `Départ : ${formData.dep}\n` +
      `Arrivée : ${formData.arr}\n\n` +
      (formData.notes ? `Notes : ${formData.notes}\n\n` : '') +
      `Contact : ${formData.email || 'Non renseigné'}`;

    window.open(`https://wa.me/${telFormatted}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-[#062614] border-2 border-[#e2b13c] rounded-xl p-8 shadow-2xl">
        <h2 className="text-2xl font-bold text-[#e2b13c] text-center mb-8 border-b border-[#e2b13c] pb-4">
          FORMULAIRE DE DEMANDE TRANSPORT PMR
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Type Client */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Type de Client *
            </label>
            <div className="flex gap-4 bg-[#14532d] p-4 rounded-lg border border-[#166534]">
              <label className="flex items-center gap-2 cursor-pointer text-white">
                <input
                  type="radio"
                  name="type"
                  value="Particulier"
                  checked={formData.type === 'Particulier'}
                  onChange={handleChange}
                  className="accent-[#22c55e]"
                />
                Particulier
              </label>
              <label className="flex items-center gap-2 cursor-pointer text-white">
                <input
                  type="radio"
                  name="type"
                  value="Société"
                  checked={formData.type === 'Société'}
                  onChange={handleChange}
                  className="accent-[#22c55e]"
                />
                Société
              </label>
            </div>
          </div>

          {/* Nom / Société */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              {formData.type === 'Particulier' ? 'Nom et Prénom' : 'Nom de la Société'} *
            </label>
            <input
              type="text"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              placeholder={formData.type === 'Particulier' ? 'Ex: Martin Dupont' : 'Ex: SARL Transport'}
              className="w-full p-3 bg-[#14532d] border border-[#166534] text-white rounded-lg focus:border-[#22c55e] focus:outline-none"
              required
            />
          </div>

          {/* Adresse de Facturation */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Adresse de Facturation *
            </label>
            <input
              type="text"
              name="adresseFacturation"
              value={formData.adresseFacturation}
              onChange={handleChange}
              placeholder="Ex: 10 rue de la République, 59000 Lille"
              className="w-full p-3 bg-[#14532d] border border-[#166534] text-white rounded-lg focus:border-[#22c55e] focus:outline-none"
              required
            />
          </div>

          {/* Nombre de Passagers */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Nombre de Passagers *
            </label>
            <select
              name="passagers"
              value={formData.passagers}
              onChange={handleChange}
              className="w-full p-3 bg-[#14532d] border border-[#166534] text-white rounded-lg focus:border-[#22c55e] focus:outline-none"
            >
              <option value="1">1 passager</option>
              <option value="2">2 passagers</option>
              <option value="3">3 passagers</option>
              <option value="4">4 passagers</option>
            </select>
          </div>

          {/* Type de Prestation */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Type de Prestation *
            </label>
            <div className="flex gap-4 bg-[#14532d] p-4 rounded-lg border border-[#166534]">
              <label className="flex items-center gap-2 cursor-pointer text-white">
                <input
                  type="radio"
                  name="typePrestation"
                  value="Trajet"
                  checked={formData.typePrestation === 'Trajet'}
                  onChange={handleChange}
                  className="accent-[#22c55e]"
                />
                Trajet
              </label>
              <label className="flex items-center gap-2 cursor-pointer text-white">
                <input
                  type="radio"
                  name="typePrestation"
                  value="Mise à disposition"
                  checked={formData.typePrestation === 'Mise à disposition'}
                  onChange={handleChange}
                  className="accent-[#22c55e]"
                />
                Mise à disposition
              </label>
            </div>
          </div>

          {/* Adresse de Départ */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Adresse de Départ *
            </label>
            <input
              type="text"
              name="dep"
              value={formData.dep}
              onChange={handleChange}
              placeholder="Ex: 10 rue Nationale, 59000 Lille"
              className="w-full p-3 bg-[#14532d] border border-[#166534] text-white rounded-lg focus:border-[#22c55e] focus:outline-none"
              required
            />
          </div>

          {/* Adresse d'Arrivée */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Adresse d'Arrivée *
            </label>
            <input
              type="text"
              name="arr"
              value={formData.arr}
              onChange={handleChange}
              placeholder="Ex: Centre Hospitalier de Lille"
              className="w-full p-3 bg-[#14532d] border border-[#166534] text-white rounded-lg focus:border-[#22c55e] focus:outline-none"
              required
            />
          </div>

          {/* Téléphone */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Téléphone (Optionnel)
            </label>
            <input
              type="tel"
              name="tel"
              value={formData.tel}
              onChange={handleChange}
              placeholder="Ex: 06 12 34 56 78"
              className="w-full p-3 bg-[#14532d] border border-[#166534] text-white rounded-lg focus:border-[#22c55e] focus:outline-none"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Email (Optionnel)
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Ex: contact@exemple.fr"
              className="w-full p-3 bg-[#14532d] border border-[#166534] text-white rounded-lg focus:border-[#22c55e] focus:outline-none"
            />
          </div>

          {/* Notes */}
          <div>
            <label className="block text-xs font-bold text-[#e2b13c] mb-2 uppercase">
              Informations Complémentaires (Optionnel)
            </label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Ex: Déambulateur, Fauteuil pliant, Horaire souhaité, etc."
              rows="4"
              className="w-full p-3 bg-[#14532d] border border-[#166534] text-white rounded-lg focus:border-[#22c55e] focus:outline-none resize-none"
            ></textarea>
          </div>

          {/* Bouton Submit */}
          <button
            type="submit"
            className="w-full bg-[#25d366] hover:bg-[#20ba59] text-white font-bold py-4 px-6 rounded-lg transition-colors duration-200 text-lg uppercase shadow-lg"
          >
            💬 Envoyer la Demande via WhatsApp
          </button>
        </form>
      </div>
    </div>
  );
};

export default ModulePMR;
